// Decode HTML entities in strings (e.g., &#8217; -> ')
const textarea = typeof document !== 'undefined' ? document.createElement('textarea') : null;

export function decodeHtmlEntities(text: string): string {
  if (!text) return text;

  if (textarea) {
    // Use browser's built-in HTML decoder
    textarea.innerHTML = text;
    return textarea.value;
  }

  // Fallback for SSR or non-browser environments
  return text
    .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(parseInt(code, 10)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, code) => String.fromCharCode(parseInt(code, 16)))
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&nbsp;/g, ' ');
}
